module.exports = __webpack_public_path__ + "img/6-June.b544deaa.jpg";